"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");require("core-js/modules/web.dom.iterable");









































































































































































































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { title: '', tableData: [], // 菜单列表数据
      newadd: false, // 新增弹窗
      isShow: false, // 是否显示
      expandedKeys: [], // 默认展开的key
      checkedKeys: [], // 默认选中的key
      droplist: [], filterText: '', isDisabl: false, isDisabl2: false, importData: { jsonFile: '', title: '导入' }, importDialog: false, treeData: [{ label: '全部', children: [] }], // 表格列
      tableColumns: [{ prop: 'functionName', label: '功能名称', isShow: true // 是否显示
      }, { prop: 'functionCode', label: '功能编码', isShow: true // 是否显示
      }, { prop: 'functionTypeCode', label: '所属类别编码', isShow: false // 是否显示
      }, { prop: 'functionTypeName', label: '所属类别名称', isShow: true // 是否显示
      }, { prop: 'id', label: '功能唯一标识', isShow: false // 是否显示
      }, { prop: 'isEnabled', label: '是否启用', formatter: _formatter.statusFormatter, isShow: true // 是否显示
      }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: false // 是否显示
      }, { prop: 'updateTime', label: '更新时间	', formatter: _formatter.dateFormatter, isShow: false // 是否显示
      }], pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', code: '', functionName: '', functionCode: '', functionTypeCode: '', isEnabled: '0', used: '' }, searchData: { functionCode: '', functionName: '', functionTypeCode: '' }, editData: { id: '', code: '', functionName: '', functionCode: '', functionTypeCode: '', isEnabled: '0', used: '' }, defaultData: { id: '', code: '', functionName: '', functionCode: '', functionTypeCode: '', isEnabled: '0', used: '' }, storages: { id: '', code: '', functionName: '', functionCode: '', functionTypeCode: '', isEnabled: '0', used: '' }, defaultProps: { children: 'children', label: 'label' }, rules: { functionName: [{ required: true, message: '请输入功能名称', trigger: 'blur' }], functionCode: [{ required: true, message: '请输入功能编码', trigger: 'blur' }], functionTypeCode: [{ required: true, message: '请选择所属类别', trigger: 'change' }], isEnabled: [{ required: true, message: '请选择是否启用或禁用', trigger: 'change' }] } };}, mounted: function mounted() {this.getdrop();this.getMenu();this.init();}, computed: { isdisabledFun: function isdisabledFun() {var self = this;if (self.editData.used === true) {return true;} else {return false;}}, isdisabledFun2: function isdisabledFun2() {var self = this;if (self.storages.functionName === self.addData.functionName && self.storages.functionCode === self.editData.functionCode && self.storages.functionTypeCode === self.addData.functionTypeCode && self.storages.isEnabled === self.addData.isEnabled && self.storages.id === self.addData.id) {return true;} else {return false;}}, isdisabledFun3: function isdisabledFun3() {var self = this;if (self.storages.functionName === self.editData.functionName && self.storages.functionCode === self.editData.functionCode && self.storages.functionTypeCode === self.editData.functionTypeCode && self.storages.isEnabled === self.editData.isEnabled && self.storages.id === self.editData.id) {return true;} else {return false;}} }, watch: { filterText: function filterText(val) {this.$refs.tree.filter(val);} }, methods: { // 获取数据
    init: function init() {this.listLoading = true;var self = this;self.getData('/api/deviceModelFunc/page', this.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;self.listLoading = false;});}, getMenu: function getMenu() {// 菜单列表
      var self = this;self.treeData[0].children = [];self.getData('/api/deviceModelFunc/tree', {}, function (res) {res.forEach(function (e) {var c = { alreadUse: false, id: e.id, label: e.label };self.treeData[0].children.push(c);});});}, jsonImport: function jsonImport() {this.importDialog = true;}, jsonExport: function jsonExport() {window.open('/api/deviceModelFunc/jsonDown');}, getFile: function getFile(event) {this.importData.jsonFile = event.target.files[0];}, zxpoponUpdate: function zxpoponUpdate() {var self = this;if (self.deviceTypeCode === '') {self.$message({ message: '请选择产品型号!', type: 'warning' });} else {self.addData.deviceTypeCode = self.deviceTypeCode;self.typeadd = false;}}, zxpoponCencal: function zxpoponCencal() {this.typeadd = false;this.$refs['addForm'].resetFields();this.templateSelection = '';}, resetFun: function resetFun() {// 重置
      this.searchData.functionName = '';this.searchData.functionCode = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.newadd = true;this.title = '新增';}, optionFun: function optionFun(data) {
      var self = this;
      self.getData('/api/deviceModelFunc/' + data.id, {}, function (res) {
        self.$router.push({
          path: '/model/modeloption/' + res.functionCode });

      });
    },
    updateItem: function updateItem(item) {// 修改操作
      this.title = '修改';
      var self = this;
      self.addData = {
        id: item.id,
        code: item.code,
        functionName: item.functionName,
        functionCode: item.functionCode,
        functionTypeCode: item.functionTypeCode,
        isEnabled: item.isEnabled + '',
        used: item.used };

      self.newadd = true;
    },
    onSubmit: function onSubmit(menu) {// 保存
      var self = this;
      if (self.newadd) {
        self.$refs.addForm.validate(function (valid) {
          if (valid) {
            var path = '/api/deviceModelFunc';
            var message = '添加成功';
            if (self.title === '修改') {
              path = '/api/deviceModelFunc/' + self.addData.id;
              message = '修改成功';
            }
            self.postData(path, {
              functionName: self.addData.functionName,
              functionCode: self.addData.functionCode,
              functionTypeCode: self.addData.functionTypeCode,
              isEnabled: self.addData.isEnabled },
            function (res) {
              self.$message({
                message: message,
                type: 'success' });

              self.newadd = false;
              self.getMenu();
              self.init();
              self.onCencal();
            });
          } else {
            return false;
          }
        });
      } else {
        self.postData('/api/deviceModelFunc/' + self.editData.id, {
          functionName: self.editData.functionName,
          functionCode: self.editData.functionCode,
          functionTypeCode: self.editData.functionTypeCode,
          isEnabled: self.editData.isEnabled },
        function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          self.getMenu();
          self.expandedKeys.push(self.editData.id + '');
          self.checkedKeys.push(self.editData.id + '');
          setTimeout(function () {
            self.$nextTick(function () {
              self.$refs.tree.setCurrentKey(self.editData.id);
              // "tree"是你自己在树形控件上设置的 ref="tree" 的名称
            });
          }, 1000);
        });
      }
    },
    onCencal: function onCencal() {
      var self = this;
      self.newadd = false;
      self.$refs['addForm'].resetFields();
      self.closeRefund();
    },
    onCencalImport: function onCencalImport() {
      var dr = document.getElementById('jsonFile');
      if (dr) {
        dr.outerHTML = dr.outerHTML;
      }
      this.importDialog = false;
    },
    onImport: function onImport(event) {
      var self = this;
      if (self.importData.jsonFile) {
        var File = new FormData();
        File.append('jsonFile', self.importData.jsonFile);
        self.postData('/api/deviceModelFunc/jsonImport', File, function (res) {
          self.$message({
            message: '导入成功!',
            type: 'success' });

          // self.onCencal()
          self.onCencalImport();
          self.searchData.page = 1;
          self.init();
        });
      } else {
        return false;
      }
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      this.addData.id = '';
      this.addData.code = '';
      this.addData.functionName = '';
      this.addData.functionCode = '';
      this.addData.functionTypeCode = '';
      this.addData.isEnabled = '0';
      this.addData.used = '';
      // done()
    },
    selectType: function selectType(item) {
      this.searchData.functionTypeCode = item.id;
      this.init();
    },
    changeScen: function changeScen(data) {// 获取模型详情
      var self = this;
      console.log('data', data);
      self.editData.code = data.id;
      if (data.children.length === 0) {
        this.isShow = true;
        self.getData('/api/deviceModelFunc/' + self.editData.code, {}, function (res) {
          self.editData = {
            functionName: res.functionName,
            functionCode: res.functionCode,
            functionTypeCode: res.functionTypeCode,
            isEnabled: res.isEnabled,
            id: res.id,
            used: res.used };

          self.storages = {
            functionName: res.functionName,
            functionCode: res.functionCode,
            functionTypeCode: res.functionTypeCode,
            isEnabled: res.isEnabled,
            id: res.id,
            used: res.used };

          self.defaultData.functionTypeCode = res.functionTypeCode;
          if (res.isEnabled === 0) {
            self.editData.isEnabled = '0';
            self.storages.isEnabled = '0';
          } else if (res.isEnabled === 1) {
            self.editData.isEnabled = '1';
            self.storages.isEnabled = '1';
          }
        });
      }
      if (data.children.length > 0) {
        self.addData.functionTypeCode = data.label;
      }
    },
    changeproductFun: function changeproductFun(data) {
      var obj = {};
      obj = this.droplist.find(function (item) {
        return item.value === data;
      });
      console.log('ssss', obj.value);
      this.addData.functionTypeCode = obj.value;
    },
    changeproductFunEdit: function changeproductFunEdit(data) {
      var obj = {};
      obj = this.droplist.find(function (item) {
        return item.value === data;
      });
      console.log('ddd', obj.value);
      this.editData.functionTypeCode = obj.value;
      this.editData.functionTypeCode = obj.value;
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/deviceModelFunc/type', {}, function (res) {
        self.droplist = res;
      });
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    } } };exports.default = _default;